import React,{useEffect,useState} from 'react'
import {AuthContext} from '../context/AuthContext'
import {GeneralesContext} from '../context/GeneralesContext'
import { authUser } from '../funciones/AuthUser'
import { TextField,IconButton,Box,Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import RefreshIcon from '@material-ui/icons/Refresh';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import TablaUsuario from './TablaUsuarios'
import NvoUsuario from './NuevoUsuario'
import { useHistory } from "react-router-dom";
const useStyles = makeStyles({
    
    buscador:{
    width:'30em'
    },
 
  });
const UsuarioInicio = () => {
    let history = useHistory();
    const {usuario,guardarUsuario}=React.useContext(AuthContext);
    const {generales,guardarGenerales}=React.useContext(GeneralesContext); 
   // let history = useHistory();  
    const[usrBusq,setUsrBusq]=React.useState({nombre:''});
    const{nombre}=usrBusq
    const classes = useStyles();
    const[actualizar,setActualizar]=useState(false);
    const [modalNvoUsrAbierto,setModalNvoUsrAbierto]= useState(false); 
    //const [modalNvoCliAbierto,setModalNvoCliAbierto]= useState(false); 
    useEffect(() => {
        
        const veriSesion =  () => {            
            let auxValidacion=authUser()
            if(!auxValidacion   )
            {   guardarUsuario([])				
                guardarGenerales([])    
                localStorage.clear();            	             
                history.push("/")	                	
            }
            else
            {   
                if (usuario.length==0) 
                {
                    guardarUsuario({Nombre:'Sistemas',nivel:1});                                         
                    
                }        
                //document.title = 'Listado Usuarios'                                 
                guardarGenerales({...generales,Titulo:'Listado Usuarios'})   
              //  conectarJSon();                                              
            }            
        }        
      veriSesion();	   
        
    }, [])

    const onChange = e =>
    {         
        let expNopermitida = new RegExp('[0-9._:$!%-({})/*|]');
        let expMenos = new RegExp('-');
        let expMas = new RegExp('[+]');     
        let expCadena = new RegExp('[A-Za-z]');
        if ((expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) && !expMenos.test(e.target.value) &&!expMas.test(e.target.value))
            ||e.target.value===' '||e.target.value==='') 
        {
            setUsrBusq({
                ...usrBusq, //copiamos el nombre
                [e.target.name] : e.target.value  
            })
        }
 
        
    };
    function abrirModalNvoUsr(){  
        console.log("abriendo modal");  
        setModalNvoUsrAbierto(true);    
      }
    let colorLetra="#0F82EE"
    const modNvoUsr = modalNvoUsrAbierto ? 
                        ( <NvoUsuario modalAbierto={modalNvoUsrAbierto}  
                            setModalAbierto={setModalNvoUsrAbierto} titulo={'Nuevo Usuario'}
                            //setActualizar={setActualizar} actualizar={actualizar}
                        />
                        ): null; 
    return (
    <Box pt={1}>
        <TextField className={classes.buscador}
            name="nombre" placeholder="Usuario"
            value={nombre} onChange={onChange}
        />
        <Tooltip title={`Actualizar lista usuarios`}>
            <IconButton aria-label="actualizar" onClick={() => setActualizar(!actualizar)} 
                component="span" size="small" 
            >
                <RefreshIcon style={{color:colorLetra  }}/>
            </IconButton>
        </Tooltip>
        <Tooltip title={`Crear Usuario`}>
            <IconButton aria-label="agregar nuevo" onClick={() => abrirModalNvoUsr()} 
                component="span" size="small" 
            >
                <AddCircleOutlineIcon style={{color:colorLetra }} />  
            </IconButton>
        </Tooltip>
        <br/> 
        {nombre.length>=3 ? <TablaUsuario auxNombre={nombre} auxActualizar={actualizar} setActualizar={setActualizar}/>:null}
        {modNvoUsr}
    </Box>
    )
}

export default UsuarioInicio
